import { isFleetMaintenanceHubCanada } from "../helpers/affiliationHelpers"
import { THOUSANDS_CODE } from "../constants/tires"

export const formatWithCommas = (number) => {
  if (number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  } else {
    return "-"
  }
}

export function formatPrice(price) {
  // eg.98 -> 98.00, 98.456 -> 98.45
  return parseFloat(price).toFixed(2)
}
export const formattedPrice = (price) => {
  if (price == null || price == undefined) return ""

  return typeof price === "number"
    ? isFleetMaintenanceHubCanada()
      ? `$${formatWithCommas(parseFloat(price).toFixed(2))} CAD`
      : `$${formatWithCommas(parseFloat(price).toFixed(2))}`
    : isFleetMaintenanceHubCanada()
    ? `$${formatWithCommas(parseFloat(price).toFixed(2))} CAD`
    : `$${formatWithCommas(parseFloat(price).toFixed(2))}`
}

export const fileSizes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes"
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}
export function formatPriceNumber(number) {
  if (number >= 1000 && number < 1000000) {
    // Format as "1k" for thousands
    return (
      (number / 1000).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      }) + THOUSANDS_CODE
    )
  } else if (number >= 1000000) {
    // Format as "1M" for millions
    return (
      (number / 1000000).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      }) + MILLIONS_CODE
    )
  } else {
    // Leave as is for numbers less than 1000
    return number.toLocaleString()
  }
}
